import styled from 'styled-components';
// import Paper from '@material-ui/core/Paper';
import { rgba } from 'polished';
import { Paper, Grid, CardMedia as MuiCardMedia } from '@mui/material';
import Typography from '../../../atoms/Typography';

export const TabContainer = styled(Paper)`
  /* margin: 2rem 0; */
  /* margin-bottom: 1rem; */
  ${({ padding }) => padding && `padding: ${padding};`}
  transition: width 225ms cubic-bezier(0.4,0,0.6,1) 0ms;
`;

export const CardMedia = styled(MuiCardMedia)`
  display: flex;
  flex-basis: 100%;
`;

export const BlackShade = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  ${({ theme }) =>
    theme &&
    `
    background-color:${rgba(theme.common.black, 0.35)};
    `}
  h5 {
    color: white;
  }
  span {
    color: ${({ theme }) => theme.secondaryColor[150]};
  }

  background: linear-gradient(180deg, rgba(33, 33, 33, 0) 0%, rgba(49, 47, 47, 0.75) 100%),
    rgba(33, 33, 33, 0.35);

  padding: 40px 0 20px 30px;
  border-bottom: 3px solid ${({ theme }) => theme.primary.main};
`;

export const OpportunityStyledBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.secondaryColor[800]};
   svg {
    margin-right: 10px;
    color: ${({ theme }) => theme.secondaryColor[600]};
  }
`;

export const Header = styled(Grid)`
  display: flex;
  align-items: center;
`;

export const ApplicationName = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  flex-grow: 1;
`;

export const ApplicationMeta = styled(Typography).attrs(() => ({
  variant: 'body1',
}))`
  && {
    line-height: 1;
    align-items: center;
    display: flex;
    margin: 0.2rem 0;
  }

  svg {
    font-size: 1.2rem;
    margin-right: 0.2rem;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  button {
    border-radius: 0;
    margin-left: 0.5rem;
  }

  && {
    margin-top: 1rem;
  }
`;

export const AverageRate = styled(Typography)`
  display: flex;
  align-items: center;
  && {
    ${({ theme }) => theme && `color: ${theme.common.rating};`}
  }
  svg {
    ${({ theme }) => theme && `color: ${theme.common.rating};`}
  }
`;
